export default __webpack_public_path__ + "static/sun_v2-94b87155328d9f626d6d6516dc342f09.png";